import { takeEvery, put, call } from "redux-saga/effects"
import { addNewProperty, getProperties, getPropertyQr, updateProperty, uploadImageByProperty, 
  deletePropertyBackend, 
  deleteImageByProperty,
  getPropertyReceipt} from "../../helpers/backend_helper"
import { ADD_NEW_PROPERTY, addPropertySuccess, DELETE_PROPERTY, deleteProperty, deletePropertySuccess,
   GET_PROPERTIES, getPropertiesSuccess, UPDATE_PROPERTY, updatePropertySuccess, getPropertiesFail,
  modalPropertyShow, 
  setPropertySaved,
  UPLOAD_IMAGE,
  UPLOAD_IMAGES_PROPERTY,
  setUploadImageSuccess,
  setProperty,
  GET_PROPERTY_QR,
  setPropertyQr,
  getPropertyGetQrSuccess,
  DELETE_IMAGE_PROPERTY_IN_CLOUD,
  GET_PROPERTY_RECEIPT} from "./actions"
  import toastr from "toastr";

/**
 * Get all active type properties 
 */
function* fetchProperties({ payload: filter }) {
    try {
      const response = yield call(getProperties, filter)
      if(response.success) {
      yield put(getPropertiesSuccess(response))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      yield put(getPropertiesFail(error))
    }
}

function* onGetPropertyReceipt({ payload: property }) {
    try {
      const response = yield call(getPropertyReceipt, property)
      yield put(setPropertyQr(response))
      yield put(getPropertyGetQrSuccess(true))

      yield put(setPropertyQr(response))

    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}

function* onGetPropertyQr({ payload: property }) {
    try {
      const response = yield call(getPropertyQr, property)
      yield put(setPropertyQr(response))
      yield put(getPropertyGetQrSuccess(true))
      //if(response.success) {
      yield put(setPropertyQr(response))
      /*} else {
        toastr.error(response.message)
      }*/
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}

function* onAddNewProperty({ payload: property }) {
    try {
      const response = yield call(addNewProperty, property)
      if(response.success) {
        toastr.success(response.message)
        yield put(addPropertySuccess(response))
        //yield put(modalPropertyShow(false))
        yield put(setPropertySaved(true))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}


function* onUpdateProperty ({ payload: property }) {
    try {
      const response = yield call(updateProperty, property)
      if(response.success) {
        toastr.success(response.message)
        yield put(updatePropertySuccess(response))
        yield put(setPropertySaved(true))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}
  
function* onDeleteProperty({ payload: property }) {
    try {
      const response = yield call(deletePropertyBackend, property)
      if(response.success) {
        toastr.success(response.message)
         yield put(deletePropertySuccess(response))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}

function* onUploadImage ({payload:data}) {
    try {
      const response = yield call(uploadImageByProperty, data)
      if(response.success) {
        yield put(setUploadImageSuccess(response.success))
        yield put(setProperty (response.data.property))
        yield put(getPropertiesSuccess ({data:response.data.list,totalItems:response.data.list.total}))
        toastr.success(response.message)
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.error(error)
      toastr.error("Hubo un error al guardar la imagen, intenta nuevamente")
    }
}

function* onDeleteImagePropertyInCloud ({payload:pic}) {
  try {
    const response = yield call(deleteImageByProperty, pic)
    if(response.success) {
      toastr.success(response.message)      
      yield put(setProperty (response.data.property))
      yield put(getPropertiesSuccess ({data:response.data.list,totalItems:response.data.list.total}))
    } else {
      toastr.error(response.message)
    }
  } catch (error) {
    console.error(error)
    toastr.error("Hubo un error al eliminar la imagen, intenta nuevamente")
  }
}

function* propertySaga() {
    yield takeEvery(GET_PROPERTIES, fetchProperties)
    yield takeEvery(GET_PROPERTY_QR, onGetPropertyQr)
    yield takeEvery(ADD_NEW_PROPERTY, onAddNewProperty)
    yield takeEvery(UPDATE_PROPERTY, onUpdateProperty)
    yield takeEvery(DELETE_PROPERTY, onDeleteProperty)
    yield takeEvery(UPLOAD_IMAGES_PROPERTY, onUploadImage)
    yield takeEvery(DELETE_IMAGE_PROPERTY_IN_CLOUD, onDeleteImagePropertyInCloud)
    yield takeEvery(GET_PROPERTY_RECEIPT, onGetPropertyReceipt)
  }
  
  export default propertySaga;
  